import Wrapper from './wrapper';
import { IWrapper, IFileResult } from './types';
import {
  IDataExportsCreateParams,
  IDataExportsGetByUserResponse,
  IDataExportsGetByUserParams,
} from '../types/my-types';

class DataExports {
  wrapper: IWrapper;
  /**
   * @param {Wrapper} wrapper
   */
  constructor(wrapper: Wrapper) {
    this.wrapper = wrapper;
  }
  create(data: IDataExportsCreateParams) {
    return this.wrapper.client.post('data-exports', data);
  }

  retrieveById(dataExportId: string) {
    return this.wrapper.client.get(`data-exports/${dataExportId}`);
  }

  retrieveByUser(params: IDataExportsGetByUserParams) {
    return this.wrapper.client.get<IDataExportsGetByUserResponse, IDataExportsGetByUserResponse>(
      `data-exports/`,
      { params }
    );
  }

  download(fileAccessUrl: string) {
    return this.wrapper.client.get<IFileResult, IFileResult>(fileAccessUrl);
  }
}

export default DataExports;
